import { render, staticRenderFns } from "./Weblog.vue?vue&type=template&id=120f9e89&scoped=true&"
import script from "./Weblog.vue?vue&type=script&lang=js&"
export * from "./Weblog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f9e89",
  null
  
)

export default component.exports